import { FIELD_REQUIRED,VALID_PHONE } from './constants';
import { keysIn, isEmpty } from '../../utils/lodash';
import { isValidPhoneNumber, isPossiblePhoneNumber } from 'react-phone-number-input';
export const validateAccountForm = (errors, { data }, key = '') => {
  const { first_name, last_name, phone, account_details, profile_id, show_job_profile } = data;
  const roles = account_details?.roles || []
  const isDemo = roles.includes('demo')
  const can_view_job_profile = show_job_profile && ((account_details?.is_installer_account || (account_details?.company_id !== null) || (!account_details?.self_installer && !account_details?.is_distributor && isDemo)) || false)
  const fieldsToValidate = {
    first_name,
    last_name,
    phone,
    ...(can_view_job_profile? {profile_id} : {})
  };
  const keysInValidateField = keysIn(fieldsToValidate);
  const noErrorObj = {
    error: false,
    errorMessage: ''
  };
  const fieldRequired = {
    error: true,
    errorMessage: FIELD_REQUIRED
  };
  const errorMessage = key => {
    const field = (fieldsToValidate[key] && fieldsToValidate[key].toString()) || '';
    if (isEmpty(field) || field === null || field === undefined) {
      errors[key] = fieldRequired;
    } 
    else if(key==="phone" && (!isValidPhoneNumber(field) || !isPossiblePhoneNumber(field))){
      errors[key] = {
        error: true,
        warning: false,
        errorMessage: VALID_PHONE
      };
    }
    else {
      errors[key] = noErrorObj;
    }
  };
  if (isEmpty(key)) {
    keysInValidateField.forEach(key => {
      errorMessage(key);
    });
  } else {
    keysInValidateField.includes(key) && errorMessage(key);
  }
  return errors;
};
